import type { GraphPayload, Manifest, NoteRecord, SearchDocument } from "./types";

async function request<T>(url: string): Promise<T> {
  const response = await fetch(url, { headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error(response.status === 404 ? "not_found" : `request_failed_${response.status}`);
  return response.json() as Promise<T>;
}

export const api = {
  manifest: () => request<Manifest>("/api/manifest"),
  graph: (version?: number) => request<GraphPayload>(`/api/graph${version ? `?v=${version}` : ""}`),
  note: (id: string, version?: number) => request<NoteRecord | { redirect: string }>(`/api/note?id=${encodeURIComponent(id)}${version ? `&v=${version}` : ""}`),
  search: (version?: number) => request<{ version: number; documents: SearchDocument[] }>(`/api/search-index${version ? `?v=${version}` : ""}`),
  async submitSuggestion(
    editId: string,
    noteId: string,
    baseContentHash: string,
    title: string,
    type: string,
    aliases: string[],
    proposedBody: string,
    comment: string
  ): Promise<{ editId: string; revision: number; status: string; snapshotVersion: number }> {
    const response = await fetch("/api/suggestions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ editId, noteId, baseContentHash, title, type, aliases, proposedBody, comment })
    });
    if (response.ok) return response.json();
    const body = await response.json().catch(() => ({}) as { error?: string });
    const messages: Record<string, string> = {
      rate_limited: "Слишком много предложений подряд — попробуйте позже.",
      not_found: "Заметка уже изменилась или была удалена.",
      payload_too_large: "Текст слишком длинный.",
      revision_conflict: "Заметка уже изменилась. Вернитесь к ней, откройте редактор заново и повторите правку."
    };
    throw new Error((body.error && messages[body.error]) || body.error || "Не удалось отправить предложение.");
  }
};
